import '../../../themes/signup.scss';

import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { BackButton } from '~/commonComponents';
import { clearForgotPasswordState } from '../../../actions';
import { CustomPortal } from '../../../commonComponents';
import history from '../../../browserHistory';
import { Header } from '../../Header';
import { ContainerLayout } from '../components/ContainerLayout';
import { ChooseVerificationMethodScreen } from './ChooseVerificationMethodScreen';
import ResetScreen from './ResetScreen';

const renderContent = (step) => {
  switch (step) {
    case 'reset':
      return <ResetScreen />;
    default:
      return <ChooseVerificationMethodScreen />;
  }
};

export default function ForgotPassword() {
  const dispatch = useDispatch();
  const [isDropdownToggleOpen, setIsDropdownToggleOpen] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const forgotPasswordFlow = useSelector((state) => state.auth.forgotPasswordFlow);

  const toggleDropdown = () => {
    setIsDropdownToggleOpen(!isDropdownToggleOpen);
  };

  useEffect(() => {
    if (forgotPasswordFlow.step === 'successful') {
      setShowSuccessModal(true);
    }
  }, [forgotPasswordFlow.step]);

  useEffect(
    () => () => {
      dispatch(clearForgotPasswordState());
    },
    [dispatch],
  );

  useEffect(() => {
    dispatch({ type: 'LOGOUT_ACTION_SUCCESS' });
  }, [dispatch]);

  return (
    <>
      <div>
        <Header
          isOpen={isDropdownToggleOpen}
          onClick={() => history.push('/')}
          toggleDropdown={toggleDropdown}
          text="Forgot Password"
        />
        <ContainerLayout>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              height: '100%',
            }}
          >
            <div style={{ marginLeft: 60, marginTop: 40, marginBottom: 40 }}>
              <BackButton url="/" />
            </div>

            {renderContent(forgotPasswordFlow.step)}
          </div>
        </ContainerLayout>
      </div>

      {showSuccessModal && (
        <CustomPortal
          dataCy="password-successfully-reset-popup"
          isSuccess={forgotPasswordFlow.step === 'successful'}
          title="Password Successfully Reset"
          text="Your password has been updated successfully! "
          submitPressed={() => history.push('/')}
          rightButtonDataCy="ok-button"
        />
      )}
    </>
  );
}
